import {financialYear} from './../../../../../interface/Units';

export const financialYearDropdown = [
  {
    label: 'April-March',
    value: financialYear.AprMar
  },
  {
    label: 'January-December',
    value: financialYear.JanDec
  },
  {
    label: 'July-June',
    value: financialYear.JulJun
  },
  {
    label: 'October-September',
    value: financialYear.OctSep
  }
];
